<template>
  <div class="add-panel-access">
    <div
      v-for="(access, index) in panelAccessData"
      :key="index"
      class="add-panel-access__access-item"
    >
      <div class="add-panel-access__access-header" v-if="index > 0">
        <span class="add-panel-access__access-title"
          >Доступ {{ index + 1 }}</span
        >
        <button
          type="button"
          class="add-panel-access__remove-access"
          @click="removeAccess(index)"
        >
          <icon-base icon-name="trash" :width="20" :height="20" />
        </button>
      </div>

      <div class="add-panel-access__type">
        <label
          ><span class="add-panel-access__required">*</span>
          <span
            >Тип— что открывает панель и как будет называться кнопка</span
          ></label
        >
        <Select
          :placeholder="
            getAvailableAccessTypes(index)[0]?.label || 'Выберите тип'
          "
          clearable
          :model-value="access.deviceTypeId"
          :options="getAvailableAccessTypes(index)"
          @update:modelValue="value => onDeviceTypeChange(index, value)"
        />
      </div>

      <div class="add-panel-access__open-method">
        <Switcher
          :on="access.usesApi"
          click-available
          @switcherClick="toggleUsesApi(index)"
        >
          {{
            access.usesApi
              ? 'Используется API для открытия (DTMF не используется)'
              : 'Используется DTMF для открытия (API не используется)'
          }}
        </Switcher>
      </div>

      <Input
        label="DTMF"
        :placeholder="`${index + 1}#`"
        :required="!access.usesApi"
        clearable
        :disabled="access.usesApi"
        v-model="access.dtmf"
      />

      <div class="add-panel-access__type">
        <label><span>Тип замка</span></label>
        <Select
          placeholder="основной или дополнительный"
          clearable
          v-model="access.lockTypeId"
          :options="lockTypesOptions"
        />
      </div>

      <Checkbox
        v-if="isEditMode && access.deviceId"
        v-model="access.regenerateLink"
        label="Перегенерировать ссылку для открытия при сохранении"
      />

      <!-- <Input label="Ссылка для открытия" clearable v-model="access.openLink">
        <template #label> Ссылка для открытия</template>
      </Input>

      <div class="add-panel-access__link-actions">
        <button
          type="button"
          :disabled="isGeneratingLink"
          class="add-panel-access__generate-link"
          @click="handleGenerateLink(index)"
        >
          Сгенерировать ссылку
        </button>
      </div> -->
    </div>

    <div class="add-panel-access__add-access" @click="addAccess">
      <icon-base icon-name="plus-outlined" :width="24" :height="24" />
      <span>Добавить доступ</span>
    </div>
  </div>
</template>

<script>
import Input from '../../Form/Input.vue'
import Select from '../../Form/Select.vue'
import Checkbox from '../../Form/Checkbox.vue'
import Switcher from '../../Switcher.vue'
import IconBase from '../../Icons/IconBase.vue'

export default {
  name: 'AddPanelAccess',
  props: {
    isGeneratingLink: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Input,
    Select,
    Checkbox,
    Switcher,
    IconBase,
  },
  data() {
    return {
      panelAccessData: [
        {
          deviceTypeId: '',
          lockTypeId: 1,
          usesApi: false,
          deviceId: null,
          dtmf: '',
          dtmfCache: '',
          openLink: '',
          isActive: true,
          regenerateLink: false,
        },
      ],
    }
  },
  computed: {
    controlledDeviceTypes() {
      return this.$store.getters.controlledDeviceTypesOptions
    },
    lockTypesOptions() {
      return this.$store.getters.lockTypesOptions
    },
    currentOrganizationId() {
      return this.$store.getters.currentOrganizationId
    },
    editingPanelId() {
      return this.$store.getters.editingPanelId
    },
    isEditMode() {
      return this.$store.getters.isEditMode
    },
  },
  watch: {
    panelAccessData: {
      handler(newVal) {
        this.$store.dispatch('setPanelData', {
          key: 'access',
          value: newVal,
        })
      },
      deep: true,
    },
  },
  mounted() {
    const storedData = this.$store.getters.panelData.access
    if (storedData && storedData.length > 0) {
      this.panelAccessData = storedData.map(item => ({
        ...item,
      }))
    }
  },
  methods: {
    getAvailableAccessTypes(currentIndex) {
      const selectedTypes = this.panelAccessData
        .map((access, index) =>
          index !== currentIndex ? access.deviceTypeId : null
        )
        .filter(type => type)

      return this.controlledDeviceTypes.filter(
        type => !selectedTypes.includes(type.id)
      )
    },
    async handleGenerateLink(index) {
      const cuid = this.$route.params.intercomId
      const panel_id = this.editingPanelId
      const device_id = this.panelAccessData[index].deviceId
      const organization_id = this.currentOrganizationId

      this.$emit('generateLink', {
        cuid,
        panel_id,
        device_id,
        organization_id,
        callback: generatedLink => {
          if (generatedLink) {
            this.panelAccessData[index].openLink = generatedLink
          }
        },
      })
    },
    addAccess() {
      if (this.panelAccessData.length >= 2) {
        this.$store.dispatch('setNotification', {
          type: 'cross-outlined',
          text: 'Максимальное количество управляемых устройств - 2',
        })
        return
      }
      this.panelAccessData.push({
        deviceTypeId: '',
        lockTypeId: 2,
        usesApi: false,
        deviceId: null,
        dtmf: '',
        dtmfCache: '',
        openLink: '',
        isActive: true,
        regenerateLink: false,
      })
    },
    applyOpenMode(item, usesApi) {
      if (usesApi === item.usesApi) return
      if (usesApi) {
        item.dtmfCache = item.dtmf
        item.dtmf = ''
      } else {
        item.dtmf = item.dtmfCache || ''
        item.dtmfCache = ''
      }
      item.usesApi = usesApi
    },
    onDeviceTypeChange(index, value) {
      const item = this.panelAccessData[index]
      item.deviceTypeId = value || ''
      this.applyOpenMode(item, !!value)
    },
    toggleUsesApi(index) {
      const item = this.panelAccessData[index]
      this.applyOpenMode(item, !item.usesApi)
    },
    removeAccess(index) {
      if (this.panelAccessData.length > 1) {
        this.panelAccessData.splice(index, 1)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.add-panel-access {
  display: flex;
  flex-direction: column;
  gap: 24px;

  &__type {
    display: flex;
    flex-direction: column;
    gap: 6px;

    label {
      display: flex;
      gap: 6px;

      span {
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        letter-spacing: -1%;
        color: $color-grey-3;
      }
    }
  }

  &__required {
    color: $color-red !important;
  }

  &__generate-link {
    align-self: flex-end;
    padding: 0;
    border: none;
    background: none;
    font-weight: 600;
    font-size: 14px;
    line-height: 22px;
    letter-spacing: -1%;
    color: $color-grey-3;
    cursor: pointer;
    transition: color 0.2s;

    &:hover {
      color: $color-default;
    }

    &[disabled] {
      cursor: progress;
      color: $color-grey-5;
    }
  }

  &__link-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
  }

  &__hint {
    font-size: 12px;
    color: $color-grey-3;
    font-weight: 400;
  }

  &__add-access {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    color: $color-default;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.7;
    }

    span {
      user-select: none;
    }
  }

  &__access-item {
    display: flex;
    flex-direction: column;
    gap: 16px;
    position: relative;

    &:not(:first-child) {
      padding-top: 16px;
      border-top: 1px dashed $color-grey-4;
    }
  }

  &__access-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
  }

  &__access-title {
    font-weight: $font-weight-lg;
    font-size: $font-size-lg;
    line-height: $line-height-lg;
    letter-spacing: -0.03em;
    color: $color-default;
  }

  &__remove-access {
    padding: 4px;
    border: none;
    background: none;
    cursor: pointer;
    color: $color-red;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: opacity 0.2s;
    margin-left: auto;

    &:hover {
      opacity: 0.7;
    }
  }

  :deep(.multiselect) {
    height: 48px !important;
    border-radius: $border-radius-xs !important;
  }

  :deep(.multiselect-wrapper) {
    height: 48px !important;
    border-radius: $border-radius-xs !important;
  }

  :deep(.multiselect-search) {
    width: calc(100% - 14px) !important;
    height: auto !important;
    top: auto !important;
    bottom: auto !important;
  }

  :deep(.multiselect-placeholder) {
    color: $input-placeholder-color !important;
  }
}
</style>
